import FlexWrapper from 'src/components/_layout/FlexWrapper/FlexWrapper'
import * as Styles from './NumbersLaunch.style'
import { CmsImage, CmsLink } from 'src/types'
import RichText from 'src/components/atoms/RichText/RichText'
import ImageReveal from 'src/components/atoms/ImageReveal/ImageReveal'
import Text from 'src/components/atoms/Text/Text'
import Padder from 'src/components/_layout/Padder/Padder'
import LineLink from 'src/components/atoms/LineLink'
import { useResponsive } from 'ahooks'
import { useMemo } from 'react'

type NumbersLaunchProps = {
    description: string
    image: CmsImage
    numbers: Array<{
        number: number
        caption: string
    }>
    link?: CmsLink
}

const NumbersLaunch: React.FC<NumbersLaunchProps> = ({
    description,
    image,
    numbers,
    link,
}) => {
    const responsiveInfo = useResponsive()
    const Image = useMemo(
        () => (
            <Styles.ImageWrapper>
                <ImageReveal {...image} />
            </Styles.ImageWrapper>
        ),
        [image]
    )
    return (
        <Styles.Wrapper>
            <FlexWrapper
                justify={{ '@initial': 'start', '@lg': 'between' }}
                align={{ '@initial': 'start', '@lg': 'center' }}
                direction={{ '@initial': 'column', '@lg': 'row' }}
                css={{ height: '100%', '@lgDown': { gap: '$sm' } }}
            >
                <Styles.ContentWrapper>
                    <Padder top="sm">
                        <RichText
                            htmlString={description}
                            css={{ paddingRight: '$colWidth' }}
                        />
                        {link && (
                            <FlexWrapper
                                justify="end"
                                css={{ paddingRight: '$colWidth' }}
                            >
                                <LineLink {...link} />
                            </FlexWrapper>
                        )}
                    </Padder>
                </Styles.ContentWrapper>
                {!responsiveInfo.lg && Image}
                <Styles.NumbersWrapper as={Padder} top="sm">
                    {numbers.map(({ number, caption }, i) => (
                        <FlexWrapper
                            key={i}
                            align="center"
                            justify={{ '@initial': 'start', '@lg': 'end' }}
                            css={{ gap: 'calc($colWidth * 0.5)' }}
                        >
                            <Text
                                css={{
                                    fontWeight: '$bold',
                                    whiteSpace: 'nowrap',

                                    fontSize: '2rem',
                                    '@lg': {
                                        fontSize: '4rem',
                                        flexGrow: 1,
                                        width: '70%',
                                    },
                                    '@xxl': {
                                        fontSize: '5rem',
                                    },
                                }}
                            >
                                + {number}
                            </Text>
                            <RichText
                                htmlString={caption}
                                textVariant="small"
                                css={{
                                    '@lg': {
                                        width: '30%',
                                        flexGrow: 0,
                                    },
                                }}
                            />
                        </FlexWrapper>
                    ))}
                </Styles.NumbersWrapper>
            </FlexWrapper>
            {responsiveInfo.lg && Image}
        </Styles.Wrapper>
    )
}

export default NumbersLaunch
